<template>
    <div data-test-view="feedback-list-requests">
        <div v-show="requestsToUser.length">
            <span
                class="clickable"
                @click="showRequestsToUser = !showRequestsToUser"
                @keyup.enter="showRequestsToUser = !showRequestsToUser"
            >
                <span class="label label-primary">
                    {{ requestsToUser.length }}
                </span>
                <span class="tw-font-bold tw-ml-2">
                    {{ $t(`userlist.show.labelAskedYou`) }}
                </span>
                <i
                    class="tw-ml-2 fal"
                    :class="{
                        'fa-caret-down': !showRequestsToUser,
                        'fa-caret-up': showRequestsToUser,
                    }"
                />
            </span>
            <hr />
        </div>
        <div v-show="showRequestsToUser">
            <div class="tw-grid tw-grid-cols-3 tw-gap-4">
                <div v-for="request in requestsToUser" :key="request._id">
                    <span
                        data-test-class="feedback-list-request"
                        class="clickable fake-link"
                        tabindex="0"
                    >
                        <span class="tw-font-bold"
                            >{{ request.sender.user.firstname }}
                            {{ request.sender.user.lastname }}</span
                        >
                    </span>
                    <div class="hr-small" />
                    <div
                        v-b-popover.hover.top="{
                            content: request.parameters.requestQuestion,
                        }"
                        class="tw-line-clamp-3"
                    >
                        {{ request.parameters.requestQuestion }}
                    </div>
                    <button
                        class="btn btn-sm btn-primary btn-raised"
                        @click="
                            onRequestClick({
                                receiver: request.sender.user._id,
                                type: 'structured',
                            })
                        "
                    >
                        {{ $t("profile.btnFeedback") }}
                    </button>
                    <button
                        class="btn btn-sm btn-default"
                        @click="
                            dismissedRequest = request._id;
                            showDismissWarning = true;
                        "
                    >
                        {{ $t("feedback.request.btnDelete") }}
                    </button>
                    <l-space :size="1" />
                </div>
            </div>
            <hr />
        </div>

        <div v-show="requestsFromUser.length">
            <span
                class="clickable"
                @click="showRequestsFromUser = !showRequestsFromUser"
                @keyup.enter="showRequestsFromUser = !showRequestsFromUser"
            >
                <span class="label label-light">
                    {{ requestsFromUser.length }}
                </span>
                <span class="tw-font-bold tw-ml-2">
                    {{ $t(`userlist.show.labelYouAsked`) }}
                </span>
                <i
                    class="tw-ml-2 fal"
                    :class="{
                        'fa-caret-down': !showRequestsFromUser,
                        'fa-caret-up': showRequestsFromUser,
                    }"
                />
            </span>
            <hr />
        </div>
        <div v-show="showRequestsFromUser">
            <div class="tw-grid tw-grid-cols-3 tw-gap-4">
                <div v-for="request in requestsFromUser" :key="request._id">
                    <span class="tw-font-bold"
                        >{{ request.receiver.user.firstname }}
                        {{ request.receiver.user.lastname }}</span
                    >
                    <div class="hr-small" />
                    <div
                        v-b-popover.hover.top="{
                            content: request.parameters.requestQuestion,
                        }"
                        class="tw-line-clamp-3"
                    >
                        {{ request.parameters.requestQuestion }}
                    </div>
                    <button
                        class="btn btn-sm btn-default btn-raised"
                        @click="
                            dismissedRequest = request._id;
                            showDismissWarning = true;
                        "
                    >
                        {{ $t("feedback.request.btnDelete") }}
                    </button>
                    <l-space :size="1" />
                </div>
            </div>
            <hr />
        </div>

        <l-confirmation-modal
            v-if="showDismissWarning"
            :text="$t('feedback.request.helpDelete')"
            @confirm="onRequestDismiss()"
            @cancel="showDismissWarning = false"
        />
    </div>
</template>

<script>
import LSpace from "./LSpace.vue";
import LConfirmationModal from "./LConfirmationModal.vue";
export default {
    components: {
        LSpace,
        LConfirmationModal,
    },
    props: {
        requestsToUser: {
            type: Array,
            required: true,
        },
        requestsFromUser: {
            type: Array,
            required: true,
        },
    },
    // A `data` property is needed so that this file is taken into account by jest's code coverage
    // (cf. https://github.com/vuejs/vue-jest/issues/32)
    //
    data() {
        return {
            showRequestsFromUser: false,
            showRequestsToUser: false,
            showDismissWarning: false,
            dismissedRequest: "",
        };
    },
    methods: {
        onRequestClick({ receiver, userFirstName, userPicture, type }) {
            this.$emit("click", { receiver, userFirstName, userPicture, type });
        },
        onRequestDismiss() {
            this.$emit("dismiss", { id: this.dismissedRequest });
            this.showDismissWarning = false;
        },
    },
};
</script>
